<template>
  <div class="card h-100">
    <img v-if="person.artwork?.thumbnail_path"
         class="card-img-top"
         :src="person.artwork.thumbnail_path"
         width="100%">
    <div class="card-body">
      <h5 class="card-title">
        {{ person.name }}
      </h5>
      <p class="card-text font-weight-bold">
        {{ person.group }} : {{ person.role }}
      </p>
      <p class="card-text">
        <span v-if="person.link">
          <a :href="person.link" target="_blank">Link</a><br>
        </span>
        <span> {{ podcasts }} | {{ episodes }}</span>
      </p>
      <ss-checkbox v-if="isPodcast" :id="`${person.uuid}_is_default`" v-model="is_default_value">
        <span class="ml-2">Default</span><span :id="`is_default_tooltip_${person.uuid}`" class="ml-2 la la-question-circle" />
      </ss-checkbox>
      <b-tooltip :target="`is_default_tooltip_${person.uuid}`" triggers="hover">
        <div v-sanitise="tooltips.person_default_tooltip" />
      </b-tooltip>
    </div>
    <div class="card-footer d-flex align-items-center justify-content-between">
      <button type="button" class="btn btn-ss" @click="toggleEditModal(person)">
        Edit
      </button>
      <button v-if="!isIndex"
              type="button"
              class="btn btn-ss"
              @click="removeSelectedPerson(person)">
        Remove
      </button>
      <button v-if="isIndex"
              type="button"
              class="btn btn-ss-danger"
              @click="deleteSelectedPerson(person)">
        Delete
      </button>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'pinia';
import { usePeopleStore } from "VueStore/app/people";
import TooltipsMixin from "VueMixins/TooltipsMixin";

export default {
  mixins: [TooltipsMixin],
  props: {
    person: {
      type: Object,
      required: true,
    },
    isPodcast: {
      type: Boolean,
      required: false,
      default: false,
    },
    isIndex: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      is_default_value: (this.isPodcast && this.person.is_default) ? 1 : 0,
    };
  },
  computed: {
    episodes() {
      if (!this.person?.items) {
        return '0 Episodes';
      }
      const count = this.person.items.length;
      let result = `${count} Episode`;
      if (count === 0 || count > 1) {
        result += 's';
      }

      return result;
    },
    podcasts() {
      if (!this.person?.feeds) {
        return '0 Podcasts';
      }
      const count = this.person.feeds.length;
      let result = `${count} Podcast`;
      if (count === 0 || count > 1) {
        result += 's';
      }

      return result;
    },
  },
  watch: {
    is_default_value(new_value) {
      const data = {
        new_value: new_value,
        person: this.person,
      };
      EventBus.$emit('person-default-toggled', data);
    },
  },
  methods: {
    ...mapActions(usePeopleStore, ['setupPersonEdit']),

    async toggleEditModal(person) {
      this.setupPersonEdit(person);
      this.fireModal('person_edit_modal');
    },

    removeSelectedPerson(person) {
      EventBus.$emit('remove-selected-person', person);
    },

    deleteSelectedPerson(person) {
      EventBus.$emit('delete-selected-person', person);
    },
  },
};
</script>
